/**
 * @file DomainGuideDialog.tsx
 * @description Окно «Подключение <домен>» (phase19.28 этап А;
 * uiux-platform-shops §5): открывается сразу после «Добавить домен» и из
 * «⋯ → Инструкция». На телефоне — во весь экран. Содержимое —
 * `DomainConnectGuide`; результат проверки берётся из свежей карточки
 * магазина (окно получает домен по id).
 */

import { hostToUnicode } from "@chaiberi/shared";

import type { ShopDomain } from "../../../lib/api-platform-shops";
import { Button } from "../../ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog";
import { DomainConnectGuide } from "./DomainConnectGuide";

interface Props {
  domain: ShopDomain | null;
  checking: boolean;
  /** Отказ проверки этого адреса — внутри окна (ревью В5). */
  checkError: string | null;
  onRecheck: (domain: ShopDomain) => void;
  onClose: () => void;
}

export function DomainGuideDialog({ domain, checking, checkError, onRecheck, onClose }: Props) {
  return (
    <Dialog open={domain !== null} onOpenChange={(open) => !open && onClose()}>
      <DialogContent fullScreen className="overflow-y-auto sm:max-h-[90vh] sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle>Подключение {domain ? hostToUnicode(domain.host.replace(/^www\./, "")) : ""}</DialogTitle>
        </DialogHeader>
        {domain ? <DomainConnectGuide domain={domain} checking={checking} checkError={checkError} onRecheck={() => onRecheck(domain)} /> : null}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Готово
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
